import { Box, Chip, Grid2, Tooltip } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PaymentIcon from '@mui/icons-material/Payment';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CreditCardIcon from '@mui/icons-material/CreditCard';

import { PaymentPlatform } from '@utriper/core';

import { useTranslation } from 'core/contexts/localization';

function getPlatformIcon(id) {
    switch (id) {
        case PaymentPlatform.IDS.cash:
            return <AttachMoneyIcon />;
        case PaymentPlatform.IDS.terminal:
        case PaymentPlatform.IDS.HostTerminal:
          case PaymentPlatform.IDS.OperatorTerminal:
            return <PaymentIcon />;
        case PaymentPlatform.IDS.link:
            return <InsertLinkIcon />;
        case PaymentPlatform.IDS.transfer:
            return <AccountBalanceIcon />;
        case PaymentPlatform.IDS.stripe:
            return <CreditCardIcon />;
        default:
            return null;
    }
}

export function PaymentPlatformChips({ paymentPlatformId, isPaymentPlatformAllowed, onClick }) {
    const { i18n } = useTranslation();
    const lang = i18n.language?.substring(0, 2);
    const normalizedLang = lang === 'es' || lang === 'en' ? lang : 'en';
    const supportedIds = PaymentPlatform.getSupportedPlatformIds({ isHost: true });

    return Object.values(PaymentPlatform.TYPES)
        .filter((platform) => supportedIds.includes(platform.id))
        .map((platform) => {
            const platformName = platform?.xlat?.[normalizedLang]?.name ?? platform?.xlat?.en?.name ?? '';
            const platformDesc = platform?.xlat?.[normalizedLang]?.desc ?? platform?.xlat?.en?.desc ?? '';

            return (
                <Grid2 key={platform.id} component={Box} hidden={!isPaymentPlatformAllowed(platform.id)}>
                    <Tooltip placement="right" title={platformDesc}>
                        <Chip label={platformName} color={paymentPlatformId === platform.id ? 'primary' : 'default'} onClick={() => onClick(platform.id)} icon={getPlatformIcon(platform.id)} />
                    </Tooltip>
                </Grid2>
            );
        });
}
